import Vue from 'vue'
import HrefPlugin from './href'

Vue.use(HrefPlugin)